<template>
  <v-popover offset="11"
             :disabled="disabled"
             open-group="archive-goal-popover"
             popoverClass="archive-goal-popover"
             @hide="resetPopover">
    <div class="flex items-center text-red
              cursor-pointer
              hover:text-red-hover group"
         :class="{'opacity-50':disabled}"
         v-tooltip="disabled && disabledTooltip">
      <span class="mr-4 transition duration-200">
        <IconFlag/>
      </span>
      <span class="text-2sm transition duration-200 border-b border-dashed border-red group-hover:border-red-hover">
        {{ $t('completeTarget') }}
      </span>
    </div>
    <template slot="popover">
      <div class="transfer-step" v-if="showTransferStep">
        <div class="col-span-2">
          <p class="text-text text-md font-bold mb-2"
             v-html="$t('transferTextMain', {
               sum: displayCurrencyValue(goalBalance,goalCurrency)
             })">
          </p>
          <p class="text-text text-md font-bold mb-6">
            {{ $t('transferTextOnAccount') }}
          </p>
          <AccountsSelect v-model="account"
                          class="mb-4"
                          :class="{'--error':$v.account.$error}"
                          :accounts="transferAccounts"
                          :account_groups="transferAccountsByGroups"
                          :grouped="accounts_by_groups.length > 1">
            <template v-slot:errors>
              <div class="error" v-if="$v.account.$invalid">{{ $t('errors.required') }}</div>
            </template>
          </AccountsSelect>
        </div>
        <BaseButton size="sm"
                    :disabled="!!submitted"
                    @click="applyTransfer"
                    theme="red">
          {{ $t('transferLabel') }}
        </BaseButton>
        <BaseButton size="sm"
                    v-close-popover
                    :disabled="!!submitted"
                    theme="white-bordered">
          {{ $t('cancelLabel') }}
        </BaseButton>
      </div>
      <div class="apply-step" v-else>
        <div class="col-span-2">
          <slot name="popover">
            <p class="text-text text-lg font-bold">{{ $t('completeTarget') }}</p>
            <p class="text-red text-2sm">{{ $t('revertIsImpossible') }}</p>
          </slot>
        </div>
        <BaseButton size="sm"
                    :disabled="!!submitted"
                    @click="applyConfirm"
                    theme="red">{{ $t('completeLabel') }}
        </BaseButton>
        <BaseButton size="sm"
                    v-close-popover
                    :disabled="!!submitted"
                    theme="white-bordered">{{ $t('cancelLabel') }}
        </BaseButton>
      </div>
    </template>
  </v-popover>
</template>

<script>
import IconFlag from "@/components/icons/IconFlag";
import BaseButton from "@/components/UI/BaseButton";
import {required} from "vuelidate/lib/validators";
import {mapGetters, mapState} from "vuex";
import AccountsSelect from "@/components/UI/BaseSelect/AccountsSelect";

export default {
  name: "FinishGoal",
  components: {AccountsSelect, BaseButton, IconFlag},
  props: {
    submitted: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledTooltip: {
      type: String
    },
    goalAccountTitle: {
      type: String
    },
    goalCurrency: {
      type: Object,
    },
    goalBalance: {
      type: Number
    }
  },
  data() {
    return {
      showTransferStep: false,
      account: null
    }
  },
  validations: {
    account: {
      required,
    },
  },
  computed: {
    ...mapState('space/accounts', ['accounts']),
    ...mapGetters('space/accounts', ['accounts_by_groups']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    transferAccounts() {
      return [...this.accounts.data].filter(acc => acc.title !== this.goalAccountTitle)
    },
    transferAccountsByGroups() {
      return [...this.accounts_by_groups].map(group => ({
        ...group,
        childs: group.childs.filter(acc => acc.title !== this.goalAccountTitle)
      }))
    },
    hasOverIncome() {
      return this.goalBalance > 0;
    }
  },
  methods: {
    resetPopover() {
      setTimeout(() => { //timeout for animations
        this.showTransferStep = false;
        this.account = null;
      }, 200)
    },
    applyConfirm() {
      if (this.hasOverIncome && !this.showTransferStep) {
        this.showTransferStep = true;
      } else {
        this.$emit('confirm')
      }
    },
    applyTransfer() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let account_id = this.account.id;
        this.$emit('confirm', {account_id})
      }
    }
  },
  i18n: {
    messages: {
      en: {
        completeTarget: 'Complete goal',
        revertIsImpossible: 'Account will be closed permanently.',
        transferTextMain: 'To complete the target, you need to transfer the accumulated amount <span class="text-red">{sum}</span>',
        transferTextOnAccount: 'to one of your accounts',
        transferLabel: 'Transfer',
        completeLabel: 'Complete',
        cancelLabel: 'Cancel'
      },
      ru: {
        completeTarget: 'Завершить цель',
        revertIsImpossible: 'Счет будет закрыт навсегда.',
        transferTextMain: 'Чтобы завершить цель, нужно перевести накопленную сумму <span class="text-red">{sum}</span>',
        transferTextOnAccount: 'на один из ваших счетов',
        transferLabel: 'Перевести',
        completeLabel: 'Завершить',
        cancelLabel: 'Отмена'
      }
    }
  }
}
</script>